import { ensureMyReferralCode } from '../api/referralApi';

/**
 * 친구초대 링크 공유 — Web Share API 우선(카카오톡 등 설치 앱이 공유 대상으로 뜸),
 * 미지원 시 클립보드 복사로 폴백.
 * @param {{ t: (key: string, vars?: object) => string, showToast: (msg: string, opts?: object) => void, referralCode?: string }} params
 * @returns {Promise<boolean>}
 */
export async function shareInviteLink({ t, showToast, referralCode }) {
  let code = referralCode;
  if (!code) {
    try {
      code = await ensureMyReferralCode();
    } catch {
      code = '';
    }
  }
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  const inviteUrl = `${origin}/auth?tab=signup${code ? `&ref=${encodeURIComponent(code)}` : ''}`;
  const shareText = t('myPage.inviteShareText');

  if (typeof navigator !== 'undefined' && navigator.share) {
    try {
      await navigator.share({ title: t('common.appName'), text: shareText, url: inviteUrl });
      return true;
    } catch (e) {
      if (e?.name === 'AbortError') return false;
      /* fall through to clipboard */
    }
  }
  try {
    await navigator.clipboard.writeText(inviteUrl);
    showToast(t('myPage.inviteCopied'), { type: 'success' });
    return true;
  } catch {
    try {
      window.prompt(shareText, inviteUrl);
    } catch {
      /* ignore */
    }
    return false;
  }
}
